'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Handyman = function Handyman(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M20.7967573 17.6504468l-7.4479265-7.44792652c.7366081-1.88244296.3273814-4.09226731-1.2276802-5.64732889-1.63690693-1.63690693-4.09226732-1.96428832-6.05655563-1.0639895l3.51934989 3.51934989-2.45536039 2.45536039-3.60119524-3.5193499c-.98214416 1.96428832-.57291742 4.41964871 1.0639895 6.05655563 1.55506158 1.5550616 3.76488594 1.9642883 5.6473289 1.2276802l7.44792647 7.4479265c.3273814.3273814.8184535.3273814 1.1458349 0l1.882443-1.8824429c.4092267-.3273814.4092267-.9002989.0818453-1.1458349z"
  }));
};

var Handyman$1 = iconStyles()(Handyman);

module.exports = Handyman$1;
